export default "__VITE_ASSET__BhKu7Fs7__"